export default __webpack_public_path__ + "static/2-6c51dcbc259efb65739dfe4e0a5582d9.jpeg";